export function debounce(func, wait, immediate = false) {
  let timeoutId = null;

  return function (...args) {
    const context = this;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (immediate) {
      const callNow = !timeoutId;

      timeoutId = setTimeout(() => {
        timeoutId = null;
      }, wait);

      // 立即执行函数
      if (callNow) {
        func.apply(context, args);
      }
    } else {
      // 非立即执行，重新设置定时器
      timeoutId = setTimeout(() => {
        func.apply(context, args);
        timeoutId = null;
      }, wait);
    }
  };
}

export const getFileFullUrl = (path) =>
  `${process.env.VUE_APP_FILE_DOMAIN}${path}`;


export const idTypeOptions=[
  {
    label:"身份证",
    value:"ID_CARD"
  },
  
  {
    label:"护照",
    value:"PASSPORT"
  },
  
  {
    label:"港澳通行证",
    value:"HK_MACAO_PASS"
  },
  
  {
    label:"台胞证",
    value:"TAIPEI_PASS"
  },
  
]